import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'emt-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    imports: [
        NgClass,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CheckboxComponent {
  @Input() control: FormControl;
  @Input() text: string;
  @Input() disabled: boolean;
  constructor() {}
}
